<template>
  <DynamicModal
    :showModal="showModalProp"
    :persistent="false"
    @clickOutside="closeModal"
    title="Import From Zoho"
    maxWidth="800px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-row class="pt-5">
        <v-col cols="12" sm="3">
          <MonthPicker
            label="Month"
            :month="month"
            :year="year"
            @monthChange="(newValue) => { this.month = newValue }"
            @yearChange="(newValue) => { this.year = newValue }"
            @periodChange="periodChangeHandler"
            :hideDetails="true"
          ></MonthPicker>
        </v-col>
        <v-col cols="12" sm="9">
          <v-autocomplete
            :items="jobOpenings"
            item-value="id"
            item-text="display_Name"
            v-model="selectedJobOpeningId"
            label="Job Opening"
            outlined
            hide-details
            @change="jobOpeningChangeHandler"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <div class="justify-center" v-if="!!selectedJobOpeningId">
        <SummaryTitle title="Client" v-if="selectedJobOpeningInfo.client_Name.name"></SummaryTitle>
        <SummaryItem itemTitle="Client Name" v-if="selectedJobOpeningInfo.client_Name.name">
          <template v-slot:content>
            {{ selectedJobOpeningInfo.client_Name.name }}
          </template>
        </SummaryItem>
        <SummaryTitle
          title="Candidate"
          v-if="!!selectedJobOpeningInfo.associated_Candidates &&
                  selectedJobOpeningInfo.associated_Candidates.length > 0"
        >
        </SummaryTitle>
        <SummaryItem
          v-if="!!selectedJobOpeningInfo.associated_Candidates &&
                  selectedJobOpeningInfo.associated_Candidates.length > 0"
          itemTitle="Candidate Name"
        >
          <template v-slot:content>
            {{ selectedJobOpeningInfo.associated_Candidates[0].first_Name }} {{ selectedJobOpeningInfo.associated_Candidates[0].last_Name }}
          </template>
        </SummaryItem>
        <SummaryItem
          v-if="!!selectedJobOpeningInfo.associated_Candidates &&
                  selectedJobOpeningInfo.associated_Candidates.length > 0 &&
                  selectedJobOpeningInfo.associated_Candidates[0].candidate_Owner"
          itemTitle="Candidate Owner"
        >
          <template v-slot:content>
            {{ selectedJobOpeningInfo.associated_Candidates[0].candidate_Owner.name }}
          </template>
        </SummaryItem>
        <SummaryTitle title="Position"></SummaryTitle>
        <SummaryItem itemTitle="Posting Title" v-if="!!selectedJobOpeningInfo.posting_Title">
          <template v-slot:content>
            {{ selectedJobOpeningInfo.posting_Title }}
          </template>
        </SummaryItem>
        <SummaryItem itemTitle="Job Type" v-if="selectedJobOpeningInfo.job_Type">
          <template v-slot:content>
            {{ selectedJobOpeningInfo.job_Type }}
          </template>
        </SummaryItem>
        <SummaryItem itemTitle="Salary" v-if="selectedJobOpeningInfo.salary">
          <template v-slot:content>
            {{ selectedJobOpeningInfo.salary }}
          </template>
        </SummaryItem>
        <SummaryItem itemTitle="Hourly Rate" v-if="selectedJobOpeningInfo.hourly_Rate">
          <template v-slot:content>
            {{ selectedJobOpeningInfo.hourly_Rate | currency }}
          </template>
        </SummaryItem>
        <SummaryItem itemTitle="Client Rate" v-if="selectedJobOpeningInfo.client_Rate">
          <template v-slot:content>
            {{ selectedJobOpeningInfo.client_Rate | currency }}
          </template>
        </SummaryItem>
        <SummaryItem itemTitle="Created By" v-if="selectedJobOpeningInfo.created_By.name">
          <template v-slot:content>
            {{ selectedJobOpeningInfo.created_By.name }}
          </template>
        </SummaryItem>
        <SummaryItem itemTitle="Account Manager" v-if="selectedJobOpeningInfo.account_Manager.name">
          <template v-slot:content>
            {{ selectedJobOpeningInfo.account_Manager.name }}
          </template>
        </SummaryItem>
        <SummaryItem itemTitle="Duration" v-if="selectedJobOpeningInfo.duration">
          <template v-slot:content>
            {{ selectedJobOpeningInfo.duration }}
          </template>
        </SummaryItem>
        <SummaryItem itemTitle="Duration Type" v-if="selectedJobOpeningInfo.duration_Type">
          <template v-slot:content>
            {{ selectedJobOpeningInfo.duration_Type }}
          </template>
        </SummaryItem>
      </div>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-6">
          <v-btn
            block
            depressed
            color="primary"
            @click="importJobOpening"
            v-if="!!selectedJobOpeningId"
          >
            Import
          </v-btn>
        </div>
        <div class="col-6">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import { MonthPicker } from '@/components/shared/datePickers'
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { SummaryItem, SummaryTitle } from '@/components/shared/display'

export default {
  components: {
    DynamicModal,
    MonthPicker,
    SummaryTitle,
    SummaryItem
  },
  data () {
    return {
      showModalProp: false,
      selectedJobOpeningId: null,
      selectedJobOpeningInfo: {}
    }
  },
  computed: {
    ...mapFields('zohoIntegration',
      [
        'jobOpenings',
        'year',
        'month'
      ])
  },
  methods: {
    ...mapActions('zohoIntegration', ['getJobOpenings']),
    periodChangeHandler () {
      this.getJobOpenings().then(() => {
        this.selectedJobOpeningId = null
      })
    },
    importJobOpening () {
      this.$emit('importFromZoho', this.selectedJobOpeningInfo)
      this.closeModal()
    },
    showModal () {
      let currentDate = new Date()
      this.year = currentDate.getFullYear()
      this.month = currentDate.getMonth() + 1
      this.selectedJobOpeningId = null
      this.selectedJobOpeningInfo = {}
      this.getJobOpenings().then(() => {
        this.showModalProp = true
      })
    },
    closeModal () {
      this.showModalProp = false
    },
    jobOpeningChangeHandler (id) {
      this.selectedJobOpeningInfo = this.jobOpenings.find(jobOpening => {
        return jobOpening.id === id
      })
    }
  }
}
</script>

<style>
.dot-leader {
  /* Center the content */
  align-items: center;
  display: flex;
  justify-content: center;
}

.dot-leader__dots {
  /* Bottom border */
  border-bottom: 1px dotted #d1d5db;

  /* Take remaining width */
  flex: 1;

  /* Spacing */
  margin: 0 0.25rem;
}
</style>
